export function normalizeBrandColorKey(value) {
    return String(value || "")
        .trim()
        .toLowerCase()
}

export function getBrandColorFromName(value) {
    const key = normalizeBrandColorKey(value)
    if (!key) return "hsl(0, 0%, 55%)"

    let hash = 0
    for (let i = 0; i < key.length; i += 1) {
        hash = (hash << 5) - hash + key.charCodeAt(i)
        hash |= 0
    }

    const hue = Math.abs(hash) % 360
    return `hsl(${hue}, 78%, 54%)`
}

/**
 * Liefert die Farbe für eine Brand. Existiert in der übergebenen colorMap ein
 * benutzerdefinierter Eintrag (Key = normalisierter Brand-Name), wird dieser bevorzugt.
 * Andernfalls wird die deterministische Farbe aus dem Namen generiert.
 */
export function resolveBrandColor(value, colorMap) {
    const key = normalizeBrandColorKey(value)
    if (key && colorMap && typeof colorMap === "object") {
        const custom = colorMap[key]
        if (typeof custom === "string" && custom.trim()) return custom.trim()
    }
    return getBrandColorFromName(value)
}
